import { style } from "@vanilla-extract/css";
import { vars } from "plos/src/styles";

export const newsSectionStyles = style({
  display: "grid",
  gap: vars.space.m,
});
